// extracted by mini-css-extract-plugin
module.exports = {"title":"issueListItem_title_1sr4vJJ","wrapper":"issueListItem_wrapper_CrK-j_c"};